import { useState } from "react"

export const useBaseModal = () => {
    const [isOpen, setIsOpen] = useState(false)
    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    return {
        isOpen,
        openModal,
        closeModal,
    }
}


// WEBPACK FOOTER //
// ./src/payment-processing/modals/useBaseModal.ts